var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressAdd = function SvgAddressAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.75 3.2a.75.75 0 1 0-1.5 0v4.05H3.2a.75.75 0 1 0 0 1.5h4.05v4.05a.75.75 0 0 0 1.5 0V8.75h4.05a.75.75 0 0 0 0-1.5H8.75z",
    clipRule: "evenodd"
  })));
};
export default SvgAddressAdd;